module.exports = __webpack_public_path__ + "img/answer3.db45feff.jpg";